import { render, staticRenderFns } from "./GraphCard.vue?vue&type=template&id=70b7b0f7&scoped=true"
import script from "./GraphCard.vue?vue&type=script&lang=js"
export * from "./GraphCard.vue?vue&type=script&lang=js"
import style0 from "./GraphCard.vue?vue&type=style&index=0&id=70b7b0f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b7b0f7",
  null
  
)

export default component.exports